export interface UpdateNotificationPreferenceRequest {
  notification: string;
}

export interface UpdateNotificationPreferenceResponse {
  success: boolean;
  myDrawNotification: string;
  error?: string;
}

export async function updateNotificationPreference(
  data: UpdateNotificationPreferenceRequest,
): Promise<UpdateNotificationPreferenceResponse> {
  const res = await fetch("/_api/auth/notification-preference", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.error || "Erreur lors de la mise à jour");
  }
  return res.json();
}

/** « Non merci » au choix du mail de résultat, mémorisé sur le compte (le réglage reste « none »). */
export async function declineNotification(): Promise<UpdateNotificationPreferenceResponse & { mailResultatRefuse: boolean }> {
  const res = await fetch("/_api/auth/notification-preference/refus", { method: "POST", credentials: "same-origin" });
  if (!res.ok) throw new Error("Erreur lors de la mise à jour");
  return res.json();
}
